import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { VisorRecord } from 'app/services/beans/Record';
import { OriginalJson, ProductofitoTransformerService } from 'app/services/productofito-transformer.service';
import { ProductosFitosanitariosService } from 'app/services/productos-fitosanitarios.service';
import { VisorFirebaseService } from 'app/services/visor-firebase.service';
import moment from 'moment';

@Component({
  selector: 'ngx-registro-editor',
  templateUrl: './registro-editor.component.html',
  styleUrls: ['./registro-editor.component.scss']
})
export class RegistroEditorComponent implements OnInit {

  @Input() public vUser: string;
  @Input() public vGroupUsers: any;

  _currentRegistro: VisorRecord = {
    fieldReference: '',
    recordData: {},
    recordType: '',
    seasonReference: '',
  };
  affectedField: any;

  productosCosechados: any[];

  imagesBaseUrl = window.location.protocol + '//' + window.location.host;

  finalidadCosechaOptions: any[] = [];
  dropdownSettingsFinalidad = {};
  destinoRestoVegetalOptions: any[] = [];
  dropdownSettingsDestino = {};


  equipos: any[] = [];
  asesores: any[] = [];
  productosFitosanitarios: any[] = [];
  productoFertilizanteOriginal: any[] = [];
  productoFertilizante: any[] = [];


  inputValue = '';
  errorMessageIni = '';
  errorMessageFin = '';
  errorMessageInun = '';
  imageUrl: string;
  enableFertirrigacion: boolean;

  @ViewChild('deleteconfirmation')
  private confirmationTpl: TemplateRef<any>;

  @Input('registro') set registro(value: any) {
    this.productosFitosanitarios = [];
    this._currentRegistro = value;

    //Transformando las fechas
    if(this._currentRegistro.recordData.fechaInicio)
       this._currentRegistro.recordData.fechaInicio = this.toDate(this._currentRegistro.recordData.fechaInicio,'DD/MM/yyyy');
    if(this._currentRegistro.recordData.fechaFin)
      this._currentRegistro.recordData.fechaFin = this.toDate(this._currentRegistro.recordData.fechaFin,'DD/MM/yyyy');
    if(this._currentRegistro.recordData.fechaInundacion)
       this._currentRegistro.recordData.fechaInundacion = this.toDate(this._currentRegistro.recordData.fechaInundacion,'DD/MM/yyyy');

    if(value.recordType == 'COSECHA'){
      this.visorFirebaseService.obtenerParcela(value.fieldReference).subscribe(data => {
        this.affectedField = data;
        this.httpClient.get('../assets/jsondata/productosCosechados.json').subscribe(items => {
            if(this.affectedField.campania != undefined && this.affectedField.campania != null &&
              this.affectedField.campania.cultivo != undefined && this.affectedField.campania.cultivo != null ){
                this.productosCosechados = (items as [any]).filter(i => i.productoCultivo == this.affectedField.campania.cultivo);
              }
            });
        });
    }

    if(value.recordType == 'TRATAMIENTO'){

      if(this._currentRegistro.recordData.tipoMedida.identifier == '1' ){
        this.cargarProductosFitosanitarios();
      }

      this.visorFirebaseService.obtenerMaquinaria().subscribe(d => {
        this.equipos = d;
      });
      this.visorFirebaseService.obtenerAsesoresAplicadores().subscribe(d => {
        this.asesores = d;
      });

    }

    if(value.recordType == 'GEOFOTO'){
      this.loadImage();
    }
    if(value.recordType == 'FERTILIZACION'){
        this.checkFertirrigacion(null);
        this.httpClient.get('./assets/jsondata/detalleFertilizante.json').subscribe(valor => {
          this.productoFertilizanteOriginal = valor as any[];
          this.filtrarMaterialFertilizante();
        });
    }

  }

  private filtrarMaterialFertilizante(){

    this.productoFertilizante = this.productoFertilizanteOriginal.filter(m =>
      m.tipoMaterial == this._currentRegistro.recordData.materialFertilizante.identifier);

      if(this._currentRegistro.recordData.materialFertilizante.identifier != this._currentRegistro.recordData.productoFertilizante.tipoMaterial) {
        this._currentRegistro.recordData.productoFertilizante = null;
      }
  }


  private async loadImage(){
    this.imageUrl = await this.visorFirebaseService.getGeofoto(this._currentRegistro);


  }


  @Output() onCloseEditor = new EventEmitter<any>();

  @Output() onDeleteItem = new EventEmitter<any>();

  @Output() onUpdateItem = new EventEmitter<any>();



  constructor(private dialogService: NbDialogService,protected visorFirebaseService: VisorFirebaseService,private httpClient:HttpClient,
              private fitosService: ProductosFitosanitariosService, private productoFitoTransformer: ProductofitoTransformerService){}

  ngOnInit() {


  }

  private toDate(value,format){
    if(value != undefined && value != null && value != ''){
      return moment(value,format);
    }
    return value;
  }

  private dateToString(value,format){
    if(value != undefined && value != null && value != ''){
      return moment(value).format(format);
    }
    return value;
  }

  closeRegistro(){
    this.onCloseEditor.emit();
  }

  deleteRegistro(){
      this.onDeleteItem.emit(this._currentRegistro.id);
  }
  promptDeleteRegistro(){
    this.dialogService.open(this.confirmationTpl);
  }
  updateRegistro(){

    //Manipulaciones:
    let item = Object.assign({},this._currentRegistro);

    //Conversiones a la hora de guardar
    item.recordData.fechaInicio = this.dateToString(item.recordData.fechaInicio, 'DD/MM/YYYY');
    item.recordData.fechaFin = this.dateToString(item.recordData.fechaFin, 'DD/MM/YYYY');


    switch(item.recordType){
      case 'SIEMBRA':
        if (this._currentRegistro.recordData.producto.name == 'ARROZ') {
          item.recordData.fechaInundacion = this.dateToString(item.recordData.fechaInundacion, 'DD/MM/YYYY');
        } else {
          item.recordData.fechaInundacion = null;
        };
      break;
      case 'TRATAMIENTO':



      break;


    }

    this.onUpdateItem.emit(item);
  }


   filtrarProductosCosechados(items){
    let cultivo = this.affectedField.campania.cultivo;
      return items.filter(i => {
        return i.productoCultivo == cultivo;
      });
  }


  // Método para manejar la entrada manual de la fecha
  handleDateInput(event: any,vFech: string) {
    this.inputValue = event.target.value;
    this.errorMessageIni = '';
    this.errorMessageFin = '';
    this.errorMessageInun = '';
    if (this.inputValue != '') {
      const parsedDate = this.parseDate(this.inputValue);
      if (parsedDate) {
        if (vFech == 'fIni') {
          this._currentRegistro.recordData.fechaInicio = parsedDate;
        } else if (vFech == 'fFin') {
          this._currentRegistro.recordData.fechaFin = parsedDate;
        } else if (vFech == 'fInun') {
          this._currentRegistro.recordData.fechaInundacion = parsedDate;
        }
      } else {
        if (vFech == 'fIni') {
          this._currentRegistro.recordData.fechaInicio = null;
          this.errorMessageIni = 'La fecha de inicio es incorrecta. Se guarda null';
        } else if (vFech == 'fFin') {
          this._currentRegistro.recordData.fechaFin = null;
          this.errorMessageFin = 'La fecha de fin es incorrecta. Se guarda null';
        } else if (vFech == 'fInun') {
          this._currentRegistro.recordData.fechaInundacion = null;
          this.errorMessageInun = 'La fecha de inundación es incorrecta. Se guarda null';
        }
      }
    }
  }

  // Función para convertir una fecha en formato dd/MM/yyyy en un objeto Date
  parseDate(dateString: string): Date | null {
    const dateParts = dateString.split('/');

    // Verificamos que haya 3 partes y que cada una tenga la longitud adecuada
    if (dateParts.length === 3 &&
        dateParts[0].length === 2 &&  // Día debe tener 2 dígitos
        dateParts[1].length === 2 &&  // Mes debe tener 2 dígitos
        dateParts[2].length === 4) {  // Año debe tener 4 dígitos

      const day = Number(dateParts[0]);
      const month = Number(dateParts[1]) - 1;  // Los meses en JS van de 0 a 11
      const year = Number(dateParts[2]);

      const date = new Date(year, month, day);

      // Verificamos si la fecha es válida comparando los componentes
      if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
        return date;
      }
    }

    return null;  // Si la fecha es inválida o el formato no es correcto, devolvemos null
  }




  cargarProductosFitosanitarios() {
    this.fitosService.queryProductos(this._currentRegistro.recordData.problematica.name).subscribe(data => {
      this.productosFitosanitarios = data.map(d => this.productoFitoTransformer.transformJson(d as OriginalJson));
    });
  }

  calcularIdProductoFito(producto){
    return producto.datosProducto.idProducto;
  }
  calcularLabelProductoFito(producto){
      return producto.datosProducto.nombre + " - " + producto.datosProducto.formulado;
  }


  calcularIdItem(item){
    return item.identifier;
  }
  calcularLabelItem(item){
      return item.nombre
  }


  onTipoProblematicaChange(){
      this._currentRegistro.recordData.problematica = {};
      this._currentRegistro.recordData.productoMedida = null;
      this._currentRegistro.recordData.registro = '';
      this.productosFitosanitarios = [];

  }
  onProblematicaChange(){
      if(this._currentRegistro.recordData.tipoMedida.identifier == '1'){
        this._currentRegistro.recordData.productoMedida = null;
        this._currentRegistro.recordData.registro = '';
        this.cargarProductosFitosanitarios();
      }
  }

  onProductoChange(){
    this._currentRegistro.recordData.registro = this._currentRegistro.recordData.productoMedida.datosProducto.numRegistro;
  }

  getGroupUserEmail(userOwnerId: string): string {
    const groupUser = this.vGroupUsers?.find(user => user.id === userOwnerId);
    return groupUser ? groupUser.email : '';
  }

  checkFertirrigacion(evento: any){
    let bpf;
    if(this._currentRegistro.recordData.buenasPracticas) bpf =  this._currentRegistro.recordData.buenasPracticas.map((b: any) => {
            return Number(b.identifier);
          });


      this.enableFertirrigacion = Number(this._currentRegistro.recordData.metodoFertilizacion.identifier) == 5
        || Number(this._currentRegistro.recordData.metodoFertilizacion.identifier) == 6 ||
        ( bpf && [4, 11, 12].some(item => bpf.includes(item))) ||
          'R' == this.affectedField.campania.sistemaExplotacion;

}

}


